import { DecimalPipe, PercentPipe } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { formatCustomPercentage, formatNumberWithSuffix } from '@utils/format-functions';

export interface IHeaders {
    name: string;
    label: string;
    format?: 'currency' | 'percent' | 'customPercent';
}

export interface ISettings {
    cols: IHeaders[];
    rows: IHeaders[];
}

@Component({
    selector: 'app-table',
    standalone: true,
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [DecimalPipe, PercentPipe]
})
export class TableComponent {
    readonly metricValues = input<Record<string, number | undefined>>();
    readonly settings = input<ISettings>({ cols: [], rows: [] });

    formatCellValue(colName: string, row: IHeaders): string | number {
        const value = this.metricValues()?.[colName + row.name] ?? 0;

        if (row.format === 'currency') return formatNumberWithSuffix(value);
        if (row.format === 'customPercent') return formatCustomPercentage(value) ?? 0;

        return value;
    }
}
